module.exports = __webpack_public_path__ + "img/ic24Post.662a1d2d.svg";